import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100%",
    width: 960,
    position: "fixed",
    bottom: 0,
    margin: "0 auto",
    borderTop: "solid 1px #ddd",
    zIndex: 999,
    backgroundColor: "#fff",
    "& .MuiBottomNavigationAction-root": {
      "@media (max-width: 768px)": {
        minWidth: "auto",
        padding: "6px 0"
      }
    },
    "& .MuiBottomNavigationAction-label.Mui-selected": {
      "@media (max-width: 480px)": {
        fontSize: 12,
      }
    },
    "&  .MuiBottomNavigationAction-label": {
      "@media (max-width: 480px)": {
        fontSize: 11,
      }
    }
  },
 
}));

export default useStyles;
